export { default } from './StarsRatingBar.js';
